import React from "react";

interface Props {
  settings: any;
  setSettings: any;
}
const AppointmentContingents = (props: Props) => {
  const {} = props;
  return <></>;
};

export default AppointmentContingents;
